export function removeEmpty(obj: any) {
  return Object.fromEntries(Object.entries(obj).filter(([v]) => v != null));
}
